module.exports = __webpack_public_path__ + "static/media/diktat-25.17a7f7c4.mp3";